export default "__VITE_ASSET__BB5aEybw__"